import {formFetch, getFetcher, postFetcher} from '@startlibs/utils'


export const formFetchWithBearer = (bearer) => (url, options) => (...args) => console.log(args) || formFetch(url, {...options,headers: new Headers({'Authorization': `Bearer ${bearer}`,'Content-Type': 'application/json; charset=UTF-8'})})(...args)
export const authFormFetch = (url, options) => formFetchWithBearer(window.sessionStorage.getItem("jwt"))(url,options)
export const urlTokenFormFetch = (url, options) => formFetchWithBearer(window.location.pathname.replace(/^.*\/share\/([^/]+).*/,'$1'))(url,options)


export const postFetcherWithBearer = (bearer) => (url, params, options) => postFetcher(url, params, {...options,headers: new Headers({'Authorization': `Bearer ${bearer}`,'Content-Type': 'application/json; charset=UTF-8'})})
export const getFetcherWithBearer = (bearer) => (url, params, options) => getFetcher(url, params, {...options,headers: new Headers({'Authorization': `Bearer ${bearer}`,'Content-Type': 'application/json; charset=UTF-8'})})


export const authGetFetcher = (url, parmas = null, options) => getFetcher(url, parmas, {...options,headers: new Headers({'Authorization': `Bearer ${window.sessionStorage.getItem("jwt")}`})})
export const authPostFetcher = (url, params, options) => postFetcherWithBearer(window.sessionStorage.getItem("jwt"))(url,params,options)


export const shareAuthGetFetcher = (url, parmas = null, options) => getFetcher(url, parmas, {...options,headers: new Headers({'Authorization': `Bearer ${window.sessionStorage.getItem("sharejwt")}`})})


export const urlTokenGetFetcher = (url, parmas = null, options) => getFetcher(url, parmas, {...options,headers: new Headers({'Authorization': `Bearer ${window.location.pathname.replace(/^.*\/share\/([^/]+).*/,'$1')}`})})

